'use client';

import Box from '@mui/material/Box';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Button from './Button';
import { MONO_FONT } from '@/theme';
import { useTranslation } from '@/i18n/LocaleProvider';

export default function PersonCardLinks({ name, profileHref, linkedin }) {
  const t = useTranslation();
  return (
    <Box
      sx={{
        mt: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      {profileHref && (
        <Button
          href={profileHref}
          variant="ghost"
          size="small"
          arrow
          aria-label={t('Ver biografía de {name}', { name })}
        >
          {t('Ver biografía')}
        </Button>
      )}
      {linkedin && (
        <Box
          component="a"
          href={linkedin}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('Perfil de LinkedIn de {name}', { name })}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '3px',
            fontFamily: MONO_FONT,
            fontSize: '11px',
            fontWeight: '500',
            color: 'text.accent',
            textDecoration: 'none',
            minHeight: '24px',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          LinkedIn{' '}
          <OpenInNewIcon sx={{ fontSize: '11px' }} aria-hidden="true" />
        </Box>
      )}
    </Box>
  );
}
